// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-card-section .card-deck-3-cols[data-v-e9f9d94c]{display:flex;flex-flow:row wrap;justify-content:center;margin-left:-15px;margin-right:-15px}.info-card-section .card-deck-3-cols .card[data-v-e9f9d94c]{flex:0 0 calc(50% - 30px);margin:15px}@media(min-width:768px){.info-card-section .card-deck-3-cols .card[data-v-e9f9d94c]{flex:0 0 calc(33.33333% - 30px)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
